export const isDev = process.env.NODE_ENV === "development";
export const getApiHost = () => process.env.API_HOST || "localhost:8080";
export const getApiScheme = () => (isDev ? "http" : "https");
export const getWsScheme = () => (isDev ? "ws" : "wss");
export const getAppVersion = () => process.env.VITE_APP_VERSION || "";
